import React, { useState, useEffect } from 'react';

const JobCountdownTimer = ({ job, onExpired }) => {
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [isNearDeadline, setIsNearDeadline] = useState(false);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    // 勤務開始時刻を計算
    const calculateWorkStartTime = () => {
      if (!job.start_date || !job.work_hours) return null;
      
      // 現在の日時を取得
      const now = new Date();
      
      // work_hoursから時間を解析 (例: "10:00-14:00", "09:00〜15:00")
      const timeMatch = job.work_hours.match(/(\d{1,2}):(\d{2})/);
      if (!timeMatch) {
        // work_hoursのパースに失敗した場合、テスト用に30分後を設定
        return new Date(now.getTime() + 30 * 60 * 1000);
      }
      
      const hours = parseInt(timeMatch[1]);
      const minutes = parseInt(timeMatch[2]);
      
      // 今日の日付で勤務開始時刻を設定
      const today = new Date();
      const workDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      workDate.setHours(hours, minutes, 0, 0);
      
      // 現在時刻より前の場合は翌日に設定
      if (workDate <= now) {
        workDate.setDate(workDate.getDate() + 1);
      }
      
      return workDate;
    };

    const updateCountdown = () => {
      const workStartTime = calculateWorkStartTime();
      if (!workStartTime) return;

      const now = new Date();
      const timeDiff = workStartTime.getTime() - now.getTime();
      
      // 勤務開始時間を過ぎた場合
      if (timeDiff <= 0) {
        setIsExpired(true);
        setTimeRemaining(null);
        if (onExpired) {
          onExpired(job.id);
        }
        return;
      }

      // 残り1時間（3600000ミリ秒）を切った場合
      const oneHourInMs = 60 * 60 * 1000;
      setIsNearDeadline(timeDiff <= oneHourInMs);

      // 残り時間を計算
      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

      setTimeRemaining({ hours, minutes, seconds });
      setIsExpired(false);
    };

    // 初回実行
    updateCountdown();

    // 1秒ごとに更新
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [job.start_date, job.work_hours, job.id, onExpired]);

  // 期限切れの場合は何も表示しない
  if (isExpired) {
    return null;
  }

  // 残り1時間を切った場合は「受付終了」の斜め帯を表示
  if (isNearDeadline) {
    return (
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-3 left-0 bg-red-500 text-white text-xs font-bold px-8 py-1 transform -rotate-45 -translate-x-4 translate-y-4 shadow-md">
          受付終了
        </div>
      </div>
    );
  }

  // カウントダウンタイマーを表示
  if (timeRemaining) {
    const { hours, minutes, seconds } = timeRemaining;
    return (
      <div className="absolute bottom-2 left-2 bg-black/70 text-white text-xs font-medium px-2 py-1 rounded-md flex items-center">
        <span className="mr-1"></span>
        <span>
          {String(hours).padStart(2, '0')}:
          {String(minutes).padStart(2, '0')}:
          {String(seconds).padStart(2, '0')}
        </span>
      </div>
    );
  }

  return null;
};

export default JobCountdownTimer;